(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationSubscriptionOptinDialogController', CommunicationSubscriptionOptinDialogController);

    CommunicationSubscriptionOptinDialogController.$inject = ['$uibModalInstance', 'entity', 'Contrat'];

    function CommunicationSubscriptionOptinDialogController($uibModalInstance, entity, Contrat) {
        var vm = this;

        vm.subscription = angular.copy(entity) || {};
        vm.isSaving = false;
        vm.clear = clear;
        vm.confirm = confirm;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm() {
            vm.isSaving = true;
            vm.subscription.optin = !vm.subscription.optin;
            if (!vm.subscription.date) {
                vm.subscription.date = new Date();
            }
            Contrat.updateCommunicationSubscription(vm.subscription, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
